import { useEffect, useState } from 'react';
import { useAuth } from './useAuth';
import { loadOfficePlanFeatures } from '../lib/planFeatures';

export function usePlanFeatures() {
  const { perfil } = useAuth();
  const [state, setState] = useState({ loading: true, code: 'starter', features: {} });

  useEffect(() => {
    let active = true;

    async function load() {
      if (!perfil?.oficina_id) {
        setState({ loading: false, code: 'starter', features: {} });
        return;
      }

      try {
        const plan = await loadOfficePlanFeatures(perfil.oficina_id);
        if (active) setState({ loading: false, ...plan });
      } catch {
        if (active) setState({ loading: false, code: 'starter', features: {} });
      }
    }

    load();
    return () => {
      active = false;
    };
  }, [perfil?.oficina_id]);

  return state;
}
